<template>
  <section class="scores-page">
    <div class="scores-page__title">
      <h1>艺术专业类方向考生<br>成绩查询</h1>
      
    </div>

    <div class="scores-panel">
      <div class="scores-panel__head">
        <h3>考生信息</h3>
        <span>共 {{ records.length }} 条成绩记录</span>
      </div>

      <div class="scores-candidate-card">
        <div class="scores-candidate-card__item">
          <span class="scores-candidate-card__label">考生姓名</span>
          <strong class="scores-candidate-card__value">{{ displayCandidateName }}</strong>
        </div>
  
        <div class="scores-candidate-card__item">
          <span class="scores-candidate-card__label">身份证号</span>
          <strong class="scores-candidate-card__value">{{ sessionProfile.idCardMasked || '--' }}</strong>
        </div>
      </div>

      <!-- <p class="scores-panel__tip">注意：列表仅显示近半年有成绩的报考记录，点击“查看详情”可查看优秀、良好、合格等真实成绩等级。</p> -->

      <p v-if="errorMessage" class="status-text status-text--error scores-panel__error">{{ errorMessage }}</p>
      <div v-else-if="loading" class="scores-empty-state">
        <h3>正在加载成绩记录</h3>
        <p>请稍候，系统正在查询成绩。</p>
      </div>
      <div v-else-if="!records.length" class="scores-empty-state">
        <h3>暂无可展示成绩</h3>
        <p>当前登录考生暂无成绩记录，请稍后再试。</p>
      </div>
      <div v-else class="scores-table">
        <div class="scores-table__head scores-table__row">
          <span>姓名</span>
          <span>科目</span>
          <span>等级</span>
          <span>成绩</span>
          <span>报名时间</span>
          <span>查看详情</span>
        </div>
        <article v-for="item in records" :key="item.candidateId" class="scores-table__row">
          <span>{{ item.candidateName || displayCandidateName }}</span>
      
          <span>{{ item.subject || '--' }}</span>
          <span>{{ item.level || '--' }}</span>
          <span class="scores-table__score">{{ item.reportScore }}</span>
          <span>{{ item.signupTime || item.examDate || '--' }}</span>
          <router-link :to="`/scores/${item.candidateId}`" class="scores-table__action">查看详情</router-link>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { fetchScoreList } from '@/api/portal'
import { getSession } from '@/utils/auth'

export default {
  name: 'ScoreListPage',
  data() {
    return {
      loading: false,
      errorMessage: '',
      records: [],
      sessionProfile: {}
    }
  },
  computed: {
    displayCandidateName() {
      return this.sessionProfile.candidateName || (this.records[0] && this.records[0].candidateName) || '--'
    },
    displayCandidateNo() {
      const firstRecord = this.records[0] || {}
      return firstRecord.admissionNo || firstRecord.candidateNo || firstRecord.candidateId || '--'
    }
  },
  created() {
    const session = getSession()
    this.sessionProfile = (session && session.profile) || {}
    this.loadRecords()
  },
  methods: {
    async loadRecords() {
      this.loading = true
      this.errorMessage = ''

      try {
        this.records = await fetchScoreList()
      } catch (error) {
        this.errorMessage = error.message || '成绩列表加载失败'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
